<template>
  <div class="lt-list" >
    <div  :class="index === 2 ? 'qq' : 'lt-item'" v-for="(item, index) in list" :key="index">
      <div class="t1">{{item.name}}</div>
      <div class="t2">{{item.issue.last_issue}}{{$t('lun')}}</div>
      <div class="t3">{{item.issue.last_code||0}}</div>
    </div>
  </div>
</template>
<script>
import homeApi from "@/api/home";
export default {
  data() {
    return {
      list: [],
    };
  },
  computed: {},
  methods: {
    info() {
      this.$toast.loading({
        message: this.$t('jiazaizhong'),
        forbidClick: true,
        duration: 0,
      });
      homeApi
        .Lotteryinfo(1)
        .then((data) => {
        // console.log(data,333)
          this.list=data.data.gameList
          this.$toast.clear();

        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.fail(err.msg);
        });
    },
  },
  mounted() {},
  created() {
    this.info();
  },
};
</script>
<style lang="less" scoped>
.qq {
  margin-top: 20px;
    padding-right: 1px;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
}
.lt-lis ::-webkit-scrollbar {
  display: none;
}
.lt-list {
  display: flex
;
    justify-content: start;
    align-items: stretch;

    box-sizing: border-box;
    white-space: nowrap;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
 
}
::-webkit-scrollbar {
  display: none;
}
.lt-item {
  margin-top: 20px;
    padding-right: 1px;
    border-right: 1px solid #b8a78a;
    width: 100%;
  
   
    text-align: center;
    margin-bottom: 20px;
}
.t1 {
  margin: auto;
    font-size: 0.35rem;
    font-weight: bolder;
    line-height: 25px;
    color: rgb(184, 167, 138);
}
.t2 {
  font-size: 12px;
    color: rgb(184, 167, 138);
    line-height: 12px;
}
.t3 {
  font-size: 12px;
    color: rgb(184, 167, 138);
    line-height: 25px;
}
</style>